import {useMutation, useQuery, UseQueryOptions} from "@tanstack/react-query";
import {WaitingQueueAPI} from "../api/waitingQueue.api";
import {waitingQueueKeys} from "./waitingQueue.keys";
import {FetchQueueStatusResponse} from "../types/waitingQueue.types";
import {queryClient} from "src/App";

export const useRegisterWaitingQueueMutation = () =>
  useMutation({
    mutationFn: WaitingQueueAPI.registerWaitingQueue,
  });

export const useGetQueueStatusQuery = (
  options?: Partial<UseQueryOptions<FetchQueueStatusResponse>>,
) =>
  useQuery({
    queryKey: waitingQueueKeys.queueStatus,
    queryFn: () => WaitingQueueAPI.fetchQueueStatus(),
    ...options,
  });

export const setQueueStatusQueryData = (data: FetchQueueStatusResponse) => {
  queryClient.setQueryData(waitingQueueKeys.queueStatus, data);
};
